import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05714146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-question" }
const _hoisted_2 = { class: "flex question-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "题库名称：", -1))
const _hoisted_4 = { class: "text_numbe" }
const _hoisted_5 = { class: "question-box" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex option" }
const _hoisted_8 = { class: "item-lef" }
const _hoisted_9 = { class: "text_numbe" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "primary_colo"
}
const _hoisted_12 = { class: "add-del flex flex-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex question-save" }

import { ref, reactive } from 'vue';
import http from '@/api/redpacket';
import router from '@/router';
import { Input, Radio, message } from 'ant-design-vue';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
// import { NumberKeyboardTheme } from 'vant';
import { VueDraggableNext } from 'vue-draggable-next';
import SvgIcon from '@/components/SvgIcon.vue';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';

interface Option {
  question_title: string;
  question_type: number;
  question_answer: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'newQuestion',
  props: {
    dataSource: null
  },
  emits: ['createStatus'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

const aInput = Input;
const aRadioGroup = Radio.Group;
const draggable = VueDraggableNext;

const studioId = router.currentRoute.value.params.studioId;



const questionForm = reactive({
  studio_id: studioId,
  contest_id: props.dataSource.questionId,
  contest_title: ref(''),
  question_info: ref(''),
});

const packetOptions = ref<Option[]>([]);
packetOptions.value.push({
  question_title: '',
  question_type: 1, // 1 单选 2 多选
  question_answer: [
    {
      answer_title: '',
      answer_options: false,
    },
    {
      answer_title: '',
      answer_options: false,
    },
    {
      answer_title: '',
      answer_options: false, // 1 正确答案
    },
  ],
});

// 拖拽
const getMulti = (e: any) => {
  // console.log(packetOptions.value, e);
};

// 选择正确答案
const rightKey = (index: number, index2: number) => {
  if (packetOptions.value[index].question_type == 1) {
    packetOptions.value[index].question_answer[index2].answer_options
      ? (packetOptions.value[index].question_answer[index2].answer_options = false)
      : (packetOptions.value[index].question_answer.forEach((item: any) => (item.answer_options = false)),
        (packetOptions.value[index].question_answer[index2].answer_options = true));
  }
  if (packetOptions.value[index].question_type == 2) {
    packetOptions.value[index].question_answer[index2].answer_options
      ? (packetOptions.value[index].question_answer[index2].answer_options = false)
      : (packetOptions.value[index].question_answer[index2].answer_options = true);
  }
};

// 添加题目
const addTitle = () => {
  packetOptions.value.push({
    question_title: '',
    question_type: 1,
    question_answer: [
      {
        answer_title: '',
        answer_options: false,
      },
      {
        answer_title: '',
        answer_options: false,
      },
      {
        answer_title: '',
        answer_options: false, // 1 正确答案
      },
    ],
  });
};

const delVisible = ref<boolean>(false);
const delIndex = ref();
// 删除题目
const delTitle = (index: number) => {
  delIndex.value = index;
  delVisible.value = true;
};
// 删除
const openDelModal = () => {
  delVisible.value = !delVisible.value;
};
// 确定删除
const okDelModal = () => {
  packetOptions.value.splice(delIndex.value, 1);
  openDelModal();
};

// 添加选项
const addOption = (index: number) => {
  packetOptions.value[index].question_answer.push({
    answer_title: '',
    answer_options: false,
  });
};

// 删除选项
const delOption = (index: number, index2: number) => {
  if (packetOptions.value[index].question_type == 2 && packetOptions.value[index].question_answer.length == 3) {
    message.error('多选题，选项不能少于3个！');
    return;
  }
  if (packetOptions.value[index].question_type == 1 && packetOptions.value[index].question_answer.length == 2) {
    message.error('单选题，选项不能少于2个！');
    return;
  }
  packetOptions.value[index].question_answer.splice(index2, 1);
};

//  保存创建
const saveCreate = () => {
  let arr = JSON.parse(JSON.stringify(packetOptions.value));
  arr.forEach((item: any) => {
    item.question_answer.forEach((i: any) => {
      i.answer_options = i.answer_options ? 1 : 0;
    });
  });
  questionForm.question_info = JSON.stringify(arr);
  http
    .addContestQuestion(questionForm)
    .then((res) => {
      if (res.data.code == 200) {
        emit('createStatus', 1);
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

const getContestQuestion = () => {
  if (!props.dataSource.questionId) return;
  let params = {
    studio_id: studioId,
    contest_id: props.dataSource.questionId,
  };
  http.getContestQuestion({ params }).then((res) => {
    if (res.data.code == 200) {
      questionForm.contest_title = res.data.data.title;
      packetOptions.value = res.data.data.question_info;
      packetOptions.value.forEach((item: any) => {
        item.question_answer.forEach((i: any) => {
          i.answer_options = i.answer_options == 1 ? true : false;
        });
      });
    }
  });
};

const init = () => {
  getContestQuestion();
};
init();

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(aInput), {
        placeholder: "请输入题库名称",
        maxlength: 150,
        size: "small",
        value: questionForm.contest_title,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((questionForm.contest_title) = $event)),
        style: {"width":"600px"}
      }, {
        suffix: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(questionForm.contest_title.length) + "/150", 1)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(draggable), {
        list: packetOptions.value,
        onChange: getMulti,
        handle: ".mover",
        onDrop: _unref(dragDrop)
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packetOptions.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "question-items",
              key: index + '-only'
            }, [
              _createVNode(SvgIcon, {
                class: "mover",
                "icon-class": "drag_icon"
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(aRadioGroup), {
                  name: "radioGroup",
                  value: item.question_type,
                  "onUpdate:value": ($event: any) => ((item.question_type) = $event)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("单选题")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("多选题")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, "Q" + _toDisplayString(index + 1) + "：", 1),
                _createVNode(_unref(aInput), {
                  value: item.question_title,
                  "onUpdate:value": ($event: any) => ((item.question_title) = $event),
                  placeholder: "请输入问题内容",
                  maxlength: 120,
                  style: {"width":"600px"}
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.question_title.length) + "/120", 1)
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.question_answer, (i, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex option",
                  key: j
                }, [
                  _createElementVNode("div", {
                    class: "item-left",
                    onClick: ($event: any) => (rightKey(index, j))
                  }, [
                    _createVNode(_component_a_radio, {
                      checked: i.answer_options,
                      "onUpdate:checked": ($event: any) => ((i.answer_options) = $event)
                    }, null, 8, ["checked", "onUpdate:checked"])
                  ], 8, _hoisted_10),
                  _createVNode(_unref(aInput), {
                    value: i.answer_title,
                    "onUpdate:value": ($event: any) => ((i.answer_title) = $event),
                    placeholder: "请输入选项内容",
                    style: {"width":"600px"}
                  }, null, 8, ["value", "onUpdate:value"]),
                  _createVNode(_unref(MinusCircleOutlined), {
                    class: "primary_color_blue",
                    style: {"margin":"0 20px"},
                    onClick: ($event: any) => (delOption(index, j))
                  }, null, 8, ["onClick"]),
                  (i.answer_options)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "正确答案"))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", {
                  onClick: ($event: any) => (addOption(index)),
                  class: "cursor"
                }, [
                  _createVNode(_unref(PlusOutlined)),
                  _createTextVNode(" 添加选项")
                ], 8, _hoisted_13),
                (packetOptions.value.length > 1)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      onClick: ($event: any) => (delTitle(index)),
                      class: "cursor"
                    }, [
                      _createVNode(SvgIcon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      }),
                      _createTextVNode(" 删除题目 ")
                    ], 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "onDrop"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("p", {
        class: "primary_color cursor",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (addTitle()))
      }, [
        _createVNode(SvgIcon, { "icon-class": "add_subject" }),
        _createTextVNode(" 添加题目")
      ]),
      _createVNode(_component_a_button, {
        class: "mod_search_form_func",
        type: "primary",
        onClick: saveCreate
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    _createVNode(CDelModal, {
      visible: delVisible.value,
      centered: "",
      close: openDelModal,
      ok: okDelModal
    }, null, 8, ["visible"])
  ]))
}
}

})